'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = X;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function X(props) {
  var width = props.width,
      height = props.height,
      color = props.color,
      shapeRendering = props.shapeRendering,
      thickness = props.thickness;


  var path = '';
  var i = void 0;

  for (i = 0; i <= thickness / 2; ++i) {
    path += 'M' + i + ' 0 L' + width + ' ' + (height - i) + ' ';
    path += 'M' + (width - i) + ' 0 L0 ' + (height - i) + ' ';
  }

  for (i = 1; i <= thickness / 2; ++i) {
    path += 'M0 ' + i + ' L' + (width - i) + ' ' + height + ' ';
    path += 'M' + width + ' ' + i + ' L' + i + ' ' + height + ' ';
  }

  var style = { stroke: color, strokeWidth: '1px' };

  return _react2.default.createElement(
    'svg',
    { width: width, height: height, style: { shapeRendering: shapeRendering } },
    _react2.default.createElement('path', { d: path, style: style })
  );
}

X.displayName = 'X';

X.propTypes = {
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  thickness: _propTypes2.default.number.isRequired,
  color: _propTypes2.default.string,
  shapeRendering: _propTypes2.default.string.isRequired
};

X.defaultProps = {
  shapeRendering: 'crispEdges',
  thickness: 1
};